module.exports = __webpack_public_path__ + "img/devOps.7a10d91a.svg";